<div>
    <h4 data-toggle="collapse" href="#collapseExample" role="button"
        aria-expanded="false" aria-controls="collapseExample"
        (click)="handleChange()">
        {{title}}

        <ng-container *ngIf="isCollapsed">
            <svg-icon src="assets/images/icon-down.svg"></svg-icon>
        </ng-container>

        <ng-container *ngIf="!isCollapsed">
            <svg-icon src="assets/images/icon-up.svg"></svg-icon>
        </ng-container>
    </h4>

    <div id="collapseExample" [ngbCollapse]="isCollapsed">
        <ng-content>
        </ng-content>
    </div>
</div>